export default {"src":"/_next/static/media/ShapeInto.fda71814.svg","height":65,"width":67};